// @flow
import { Component } from "react";
import { connect } from "react-redux";
import { listenOnMediaQuery } from "utils/domUtils";
import bindActions, { types as ats } from "../../actions";

type OwnProps = {|
    query: string,
    children: any,
|};

type Props = {
    ...OwnProps,
    [string]: Function,
};

export class ResponsiveWidthMonitor extends Component<Props> {
	componentDidMount() {
		const result = listenOnMediaQuery(this.props.query,
			(e) => this.updateIsResponsiveWidth(e.matches));

		this.updateIsResponsiveWidth(result.matches);
	}

	updateIsResponsiveWidth(result: boolean) {
		this.props[ats.SET_IS_RESPONSIVE]({ isResponsiveWidth: result });
	}

	render() {
		return this.props.children;
	}
}

export default connect<Props, OwnProps, _, _, _, _>(null, bindActions)(ResponsiveWidthMonitor);
